@if (showProgress) {
<div
  [ngClass]="{
    'progress-wrapper': true,
    'progress-card-style': isInsideCard,
    'restricted-style': product.restricted && !isInsideCard
  }"
>
  <ion-progress-bar
    [value]="progressPercentage / 100"
    [ngClass]="{
      'progress-complete': isComplete,
      'restricted-bar': product.restricted && !isInsideCard
    }"
  />
  <div class="progress-info">
    @if (totalProductsSoldType === 'percentage') {
    <span>
      {{ "product-progress-bar.sold-lots" | translate }}:
      {{ progressPercentage.toFixed(0) }}%
    </span>
    } @if (totalProductsSoldType === 'nominal') {
    <span> {{ progressValue }}/{{ product.max_quote }} </span>
    } @if (showVerified) {
    <span>
      {{ product.assistants_verified }} {{ "products.verified" | translate }}
    </span>
    } @if (isDirectSale) {
    <span>
      <span class="tap-hint">
        <ion-icon name="ticket-outline" class="hint-icon"></ion-icon>
        {{ "payment-product-modal.generate-ticket" | translate }}
      </span>
    </span>
    }
  </div>
</div>
}
